var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup33(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 107,
    viewBox: "0 0 107 107",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M53.3366 22.0548C58.5196 22.0548 62.7213 17.8531 62.7213 12.6701C62.7213 7.48707 58.5196 3.2854 53.3366 3.2854C48.1536 3.2854 43.9519 7.48707 43.9519 12.6701C43.9519 17.8531 48.1536 22.0548 53.3366 22.0548Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5681 16.115C66.9906 23.0822 60.7749 28.3114 53.3377 28.3114C45.9004 28.3114 39.6847 23.0822 38.1073 16.115C32.5129 17.3615 28.3118 22.3459 28.3118 28.3114V40.8244C28.3118 44.2735 31.1193 47.081 34.5683 47.081C38.0173 47.081 40.8248 44.2735 40.8248 40.8244V34.5679H65.8508V40.8244C65.8508 44.2735 68.6583 47.081 72.1073 47.081C75.5563 47.081 78.3638 44.2735 78.3638 40.8244V28.3114C78.3636 22.3459 74.1622 17.3615 68.5681 16.115Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.824 79.74C97.335 77.1483 91.5956 78.686 89.004 83.1749C86.4125 87.6633 87.9503 93.4032 92.4392 95.9944C96.9277 98.5861 102.876 97.048 105.467 92.5596C108.059 88.0709 106.312 82.3315 101.824 79.74Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0984 58.3735L85.2622 52.1169C82.2751 50.3924 78.4402 51.42 76.7157 54.4071C74.9911 57.3942 76.0187 61.2291 79.0058 62.9536L84.4242 66.0818L71.9111 87.7549L66.4928 84.6268C63.5057 82.9023 59.6708 83.9298 57.9463 86.917C56.2218 89.9041 57.2493 93.739 60.2364 95.4635L71.0727 101.72C76.2394 104.703 82.6565 103.556 86.5329 99.3348C81.2879 94.4853 79.8669 86.4878 83.5856 80.0466C87.3042 73.6055 94.9406 70.8376 101.763 72.9548C103.481 67.4871 101.265 61.3562 96.0984 58.3735Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.6714 83.1752C15.0797 78.6863 9.34033 77.1485 4.85143 79.7403C0.362953 82.3318 -1.38385 88.0712 1.20802 92.5601C3.79926 97.0486 9.74765 98.5866 14.2361 95.995C18.725 93.4033 20.2629 87.6637 17.6714 83.1752Z",
    fill: "#BAE3F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.7288 86.9171C47.0043 83.93 43.1692 82.9026 40.1823 84.6269L34.764 87.7551L22.2509 66.0819L27.6692 62.9538C30.6563 61.2292 31.6837 57.3942 29.9594 54.4073C28.2349 51.4201 24.3998 50.3928 21.4129 52.1171L10.5766 58.3736C5.40998 61.3563 3.19397 67.4872 4.91203 72.9552C11.7344 70.8377 19.3711 73.6058 23.0897 80.047C26.8083 86.4881 25.3874 94.4854 20.1424 99.3352C24.0187 103.557 30.4359 104.703 35.6026 101.72L46.4388 95.4636C49.4257 93.7391 50.4533 89.904 48.7288 86.9171Z",
    fill: "#BAE3F9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 106.675,
    height: 106.675,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup33);
export default __webpack_public_path__ + "static/media/Group-33.778cc72293afa35e76a2c93591b673ca.svg";
export { ForwardRef as ReactComponent };